import { FormStore } from "bundles/BigqueryQueryViewer/store";
import I18n from "lib/I18n";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { BsRobot } from "react-icons/bs";
import { promptTextArea } from "./style.module.css";

interface PromptProps {
  store: FormStore;
  width: number;
}

export const Prompt = observer((props: PromptProps) => {
  const { store, width } = props;

  const onKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if ((e.ctrlKey || e.metaKey) && e.key == "Enter") {
      store.editQuery();
    }
  };

  const onCancel = () => {
    store.cancelEditQuery();
  };

  const onAccept = () => {
    store.acceptEditQuery();
  };

  const commonStyle: React.CSSProperties = {
    position: "absolute",
    bottom: 20,
    left: "auto",
    right: "auto",
    width: "100%",
  };
  return (
    <>
      <div style={commonStyle}>
        <div
          className="p-1"
          style={{ width, margin: "0 auto", position: "relative" }}
        >
          <InputGroup
            size="sm"
            style={{
              boxShadow: "0px 6px 6px -6px rgb(0 0 0 / .25)",
            }}
          >
            <InputGroup.Text>
              <BsRobot />
            </InputGroup.Text>
            <Form.Control
              placeholder={I18n.t(
                "bigquery_query_viewer.label.prompt_query_change",
              )}
              as="textarea"
              style={{
                resize: "none",
              }}
              className={promptTextArea}
              value={store.prompt}
              onChange={(e) => (store.prompt = e.currentTarget.value)}
              onKeyDown={onKeyDown}
              disabled={store.isQueryEditing}
            ></Form.Control>
          </InputGroup>
          <div
            style={{
              position: "absolute",
              right: 4,
              bottom: 4,
              zIndex: 100,
              display: store.isUserQueryEditing ? "block" : "none",
            }}
          >
            <Button
              size="sm"
              variant="secondary"
              className="me-2"
              onClick={onCancel}
            >
              {I18n.t("bigquery_query_viewer.label.cancel")}
            </Button>
            <Button size="sm" variant="primary" onClick={onAccept}>
              {I18n.t("bigquery_query_viewer.label.done")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
});
